import { render, staticRenderFns } from "./i-modal-form.vue?vue&type=template&id=0c5b3f1a&scoped=true&"
import script from "./i-modal-form.vue?vue&type=script&lang=js&"
export * from "./i-modal-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b3f1a",
  null
  
)

export default component.exports